import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { academicWork, publications } from "./data";
import { Reveal } from "./Reveal";

export function AcademicSection() {
  const [open, setOpen] = useState(false);
  return (
    <section className="section academic-section">
      <div className="container">
        <Reveal>
          <div className="section-label"><span className="chapter-no">07</span>Research &amp; academic work</div>
          <div className="section-head"><h2>Committed to learning, sharing and better care.</h2><p>Selected publications, presentations and posters.</p></div>
        </Reveal>
        <Reveal delay={0.1}>
          <button className={`academic-toggle ${open ? "open" : ""}`} onClick={() => setOpen(!open)} data-testid="academic-toggle" aria-expanded={open}>
            <span>Publications, papers presented &amp; posters<small>Tap to {open ? "hide" : "view"}</small></span>
            <ChevronDown size={20} />
          </button>
        </Reveal>
        <AnimatePresence initial={false}>
          {open && (
            <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }} style={{ overflow: "hidden" }}>
              <div className="academic-grid" data-testid="academic-grid">
                <div className="publication-list">
                  {publications.map(([title, source], index) => (
                    <article className="publication-item" key={title} data-testid={`publication-${index}`}><span className="publication-number">0{index + 1}</span><div><h3>{title}</h3><p>{source}</p></div></article>
                  ))}
                </div>
                <div className="academic-side">
                  {Object.entries(academicWork).map(([heading, items]) => (
                    <div className="academic-group" key={heading}><h3>{heading}</h3>{items.map((item) => <p key={item}><Check size={14} /> {item}</p>)}</div>
                  ))}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
}
